/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { MemberRelative } from './MemberRelative';
import {
    MemberRelativeFromJSON,
    MemberRelativeFromJSONTyped,
    MemberRelativeToJSON,
} from './MemberRelative';

/**
 * 
 * @export
 * @interface GetAccountMembershipRelatives200Response
 */
export interface GetAccountMembershipRelatives200Response {
    /**
     * 
     * @type {Array<MemberRelative>}
     * @memberof GetAccountMembershipRelatives200Response
     */
    data: Array<MemberRelative>;
    /**
     * 
     * @type {Metadata}
     * @memberof GetAccountMembershipRelatives200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the GetAccountMembershipRelatives200Response interface.
 */
export function instanceOfGetAccountMembershipRelatives200Response(value: object): value is GetAccountMembershipRelatives200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function GetAccountMembershipRelatives200ResponseFromJSON(json: any): GetAccountMembershipRelatives200Response {
    return GetAccountMembershipRelatives200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembershipRelatives200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembershipRelatives200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberRelativeFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function GetAccountMembershipRelatives200ResponseToJSON(value?: GetAccountMembershipRelatives200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberRelativeToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

